<script>
import AlertDialog from '@components/alert-dialog.vue'
import layout from '@src/mixins/layout.vue'
import ComingSoonTooltip from '../tooltips/coming-soon-tooltip.vue'
import { navComputed, navMethods } from '@state/helpers'
import { exportService } from '@services/ExportService'
import { healthRecordsList } from '@views/safehaven/health-record/health-record-data'
import { featuresService } from '@services/safehaven/FeaturesService'
import { operationalService } from '@/src/services/safehaven/OperationService'
import { menuData } from './safehaven-nav-drawer-data'

export default {
  components: { ComingSoonTooltip, AlertDialog },
  mixins: [layout],

  data() {
    return {
      links: [],
      displayLink: false,
      displayURL: true,
      currentURL: this.$router.currentRoute.path,
      isShowAlert: false,
      alertTitle: 'You are now leaving this website',
      alertMesasge:
        ' You are being redirected to an external site. Would you like to proceed?',
    }
  },

  computed: {
    ...navComputed,
    drawerWidth() {
      return this.notDesktop ? '330' : '200'
    },
  },

  created() {
    this.currentUser = JSON.parse(localStorage.getItem('auth.currentUser'))
    this.links = menuData
    this.getFeaturesData()
  },
  mounted() {
    window.addEventListener('resize', this.changeDimensions)
    if (!this.notDesktop) {
      this.setDrawer({
        value: true,
        drawer: 'navDrawer',
      })
    }
  },
  unmounted() {
    window.removeEventListener('resize', this.changeDimensions)
  },
  methods: {
    ...navMethods,
    async getFeaturesData() {
      this.healthHelp = []

      try {
        var orgId = {
          organization_id: this.currentUser.user.user_org_details[0].org,
        }
        await featuresService.getFeatures(orgId).then((res) => {
          this.isloading = false
          // this.links = res.data.nav_bar
          this.$store.dispatch('profileQuestions/setFeatures', res.data)
        })
      } catch (error) {
        this.isLoading = false
        console.warn(error)
      }
    },
    changeDimensions() {
      const webWidgetIFrame = document.querySelector('iframe#webWidget')
      const mainboardObj = document.querySelector('.v-main__wrap')
      const topbarObj = document.querySelector('.v-toolbar')
      if (webWidgetIFrame) {
        webWidgetIFrame.style.width = window
          .getComputedStyle(mainboardObj, null)
          .getPropertyValue('width')
        webWidgetIFrame.style.height =
          window.innerHeight -
          parseInt(
            window.getComputedStyle(topbarObj, null).getPropertyValue('height')
          ) +
          10 +
          'px'
      }
    },
    showSupportDialog(isShow) {
      if (isShow) {
        const iframe = document.querySelector('iframe#launcher')
        const innerDoc = iframe.contentDocument || iframe.contentWindow.document
        const supportBtn = innerDoc.querySelector('[data-testid=launcher]')
        supportBtn.click()
        setTimeout(() => {
          this.changeDimensions()
        }, 300)
      } else {
        try {
          const iframe = document.querySelector('iframe#webWidget')
          if (iframe) {
            const innerDoc =
              iframe.contentDocument || iframe.contentWindow.document
            innerDoc
              .querySelector("[data-garden-id='buttons.icon_button']")
              .click()
          }
        } catch (error) {
          console.warn(error)
        }
      }
    },
    showAlert() {
      this.isShowAlert = true
    },
    hideAlert() {
      this.isShowAlert = false
    },
    handleSuccess() {
      this.isShowAlert = false
      window.open('https://www.youtube.com/channel/UCjuVY7k9HsY4Ebj1D0dL0SA')
    },
    drawerInput(value) {
      if (this.navDrawer !== value)
        this.setDrawer({
          value: value,
          drawer: 'navDrawer',
        })
    },
    toggleDrawer(drawer) {
      this.setDrawer({
        value: !this.getDrawer(drawer),
        drawer: drawer,
      })
    },
    async exportToPdf() {
      try {
        this.exportLoading = true
        const { data } = await exportService.create({
          hr_types: healthRecordsList,
        })
        window.open(data)
      } catch (error) {
        console.warn(error)
      }
    },
    navigateTo(routeName, index) {
      this.saveOperation({
        organization_id: this.currentUser.user.user_org_details[0].org,
        feature_id: index.id,
      })
      if (index.feature_status === 'active') {
        this.$router.push({
          name: routeName,
        })
      }
    },
    currentPath() {
      if (
        this.$router.currentRoute.path ===
        '/safehaven/share-record-link-expired'
      ) {
        this.displayLink = true
      }
    },

    async saveOperation(req) {
      try {
        await operationalService.saveOperation(req).then((res) => {})
      } catch (error) {
        console.warn(error)
      }
    },
  },
}
</script>

<template>
  <v-container fluid class="pa-0">
    <AlertDialog
      :show-alert="isShowAlert"
      :alert-title="alertTitle"
      :alert-message="alertMesasge"
      @success="handleSuccess"
      @close-alert="hideAlert"
    ></AlertDialog>
    <v-navigation-drawer
      v-if="
        this.$router.currentRoute.path ===
        '/safehaven/share-record-link-expired'
          ? displayLink
          : displayURL
      "
      :value="navDrawer"
      :width="drawerWidth"
      height="100vh"
      clipped
      dark
      left
      app
      :class="[
        currentUser.user.user_org_details[0].org_name === 'safehaven'
          ? $style.sideBarClass
          : $style.sideBarHealthbookClass,
      ]"
      @input="drawerInput"
    >
      <div class="h-100 d-flex flex-column justify-space-between">
        <div class="d-flex flex-column">
          <div v-if="mobile" :class="$style.notificationsContainer">
            <div class="d-flex flex-row justify-space-between">
              <v-app-bar-nav-icon
                v-if="notDesktop"
                color="white"
                @click.stop="toggleDrawer('navDrawer')"
              ></v-app-bar-nav-icon>
            </div>
          </div>
          <v-list nav dense>
            <div :class="$style.navHeader">
              <router-link :to="{ name: 'health-help' }">
                <v-btn :class="$style.healthHelpActionBtn">
                  <v-img
                    :class="[$style.helpActionIcon]"
                    :src="require('@assets/images/safehaven/health_help.svg')"
                  ></v-img>
                  Get HB+ Help
                </v-btn>
              </router-link>
            </div>

            <v-list-item
              v-for="link in links"
              v-show="link.feature_status !== 'disabled'"
              :key="link.id"
              :disabled="link.disabled"
              :class="$style.group"
              :active-class="$style.activeGroup"
              @click="navigateTo(link.feature_route, link)"
            >
              <v-list-item-title :class="$style.linkText">
                <ComingSoonTooltip
                  v-if="link.feature_status === 'inactive'"
                  bottom
                >
                  <div class="d-flex flex-row justify-start align-center">
                    <v-img
                      :class="$style.navItemLogo"
                      :src="
                        require(`@assets/images/safehaven/menu_icons/${link.icon_name}.svg`)
                      "
                    />
                    <span :class="$style.linkText">{{
                      $t(link.display_name)
                    }}</span>
                  </div>
                </ComingSoonTooltip>

                <div
                  v-else-if="link.feature_route === 'videos'"
                  class="d-flex flex-row justify-start align-center"
                  @click="showAlert"
                >
                  <v-img
                    :class="$style.navItemLogo"
                    :src="
                      require(`@assets/images/safehaven/menu_icons/${link.icon_name}.svg`)
                    "
                  />
                  <span :class="$style.linkText">{{
                    $t(link.display_name)
                  }}</span>
                </div>

                <div v-else class="d-flex flex-row justify-start align-center">
                  <v-img
                    :class="$style.navItemLogo"
                    :src="
                      require(`@assets/images/safehaven/menu_icons/${link.icon_name}.svg`)
                    "
                  />
                  <span :class="$style.linkText">{{
                    $t(link.display_name)
                  }}</span>
                </div>
              </v-list-item-title>
            </v-list-item>

            <v-list-item
              v-if="currentUser.is_superadmin"
              :class="$style.group"
              :active-class="$style.activeGroup"
              @click="navigateTo('admin-operations', '')"
            >
              <v-list-item-title :class="$style.linkText">
                <span :class="$style.linkText"> Operations </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-navigation-drawer>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.notificationsContainer {
  min-height: 50px;
}
.logouticon {
  margin: 8px 14px -3px 8px !important;
}
.linkText {
  flex: 0 1 auto !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 41px;
  text-align: left;
  letter-spacing: 0;
}
.signOutText {
  margin-bottom: 26px !important;
  margin-left: 26px !important;
  font-size: 14px;
  font-weight: 400;
  line-height: 41px;
  text-align: left;
  letter-spacing: 0;
}
.sideBarClass {
  padding-bottom: 30px;
  background-color: #0476d9 !important;
}
.sideBarHealthbookClass {
  padding-bottom: 30px;
  background-color: #082787 !important;
}
.alignclss {
  text-align: right;
}
.menuIcon {
  width: 24px;
  height: 24px;
  margin: 8px 14px 8px 8px !important;
}
.vCardTitle {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2c3a4b;
}

.navHeader {
  width: 100%;
  padding: 48px 10px 32px 10px;
}
.healthHelpActionBtn {
  width: 100%;
  height: 40px;
  font-size: 14px !important;
  font-weight: bold !important;
  color: #f9fafb !important;
  text-transform: capitalize !important;
  background: linear-gradient(180deg, #84b25a 0%, #698e48 100%);
}
.helpActionIcon {
  flex: none !important;
  width: 18px;
  height: 18px !important;
  margin-right: 4px;
}

.navItemLogo {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: 3px 6px 0 10px;
}
@media screen and (max-width: 960px) {
  .linkText {
    font-size: 16px;
  }

  .signOutText {
    font-size: 18px;
  }
}
@media screen and (max-width: 599px) {
  .menuIcon {
    margin: 8px 20px 8px 20px !important;
  }
  .logouticon {
    margin: 8px 20px -3px 20px !important;
  }
  .notificationsContainer {
    padding: 28px 22px !important;
  }
}
.activeGroup {
  background: #0056a1;
}
</style>

<style scoped>
/* custom css to override vuetify classes */

/* stylelint-disable */
/deep/ .theme--light.v-list-item--active::before,
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item:focus::before,
.theme--light.v-list-item:hover::before,
.theme--dark.v-list-item--active::before,
.theme--dark.v-list-item--active:hover::before,
.theme--dark.v-list-item:focus::before,
.theme--dark.v-list-item:hover::before {
  opacity: 0;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px;
}

/deep/ .v-navigation-drawer__border {
  display: none;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 0.95 !important;
}

.v-list--nav {
  padding: 0px;
}

.v-list--nav .v-list-item,
.v-list--nav .v-list-item:before {
  border-radius: 0px;
}
.v-list--nav .v-list-item {
  padding: 0px 10px;
  min-height: inherit;
}
.v-list--nav .v-list-item:first-child {
  margin-top: 40px;
}
/* stylelint-enable */
</style>
